import { useContext, useEffect, useState } from 'react'
import Image from 'next/image'
import { Product } from 'types/common-types'
import formatPrice from '../utils/formatPrice'
import toast from 'react-hot-toast'
import isSalesforceId from '../utils/isSalesforceId'
import SalesforceContentfulLinks from './Products/SalesforceContentfulLinks'
import { CartContext } from 'context/Cart'
import displayQuoteUpdatedToast from 'utils/displayQuoteUpdatedToast'
import { AuthContext } from 'context/Auth'
interface Props {
	product: Product
	cartQuantity: number
	region: 'ladoe' | 'standard' | 'teks'
}

export default function ProductListItem({ product, cartQuantity, region }: Props) {
	const { isEmployee } = useContext(AuthContext)
	const { addToCart, cart } = useContext(CartContext)
	const [quantity, setQuantity] = useState(cartQuantity)
	const disable = !isSalesforceId(product.salesforceProductId)
	const item = {
		id: product.sys.id,
		name: product.name,
		sku: product.sku,
		slug: product.slug,
		price: product.price,
		quantity: quantity,
		salesforceProductId: product.salesforceProductId,
		image:
			product.imagesCollection.items.length > 0
				? product.imagesCollection.items[0].url
				: '/images/product-image-placeholder.jpg',
		region
	}

	useEffect(() => {
		if (quantity !== cartQuantity) {
			addToCart(item)
			displayQuoteUpdatedToast(cart)
		}
	}, [quantity])

	return (
		<div
			id={item.slug}
			className={`mb-5 flex scroll-mt-20 items-center justify-between ${disable ? 'opacity-50' : 'opacity-100'}`}
		>
			<div className="flex items-center gap-4">
				<div className="relative h-24 w-24">
					<Image src={item.image} alt={item.name} layout="fill" objectFit="contain" />
				</div>
				<div>
					<h3 className="mt-3 text-base sm:text-lg">{item.name}</h3>
					{isEmployee && <span className="mb-1 block text-xs text-slate-400 sm:text-sm">{item.sku}</span>}
					<div className="flex gap-3">
						{process.env.NEXT_PUBLIC_ACTIVE_ENV === 'development' && (
							<SalesforceContentfulLinks item={product} />
						)}
					</div>
				</div>
			</div>

			<div className="mt-4 flex items-center gap-4">
				<span className={`text-lg font-bold ${disable ? 'text-red-400' : 'text-slate-700'}`}>
					{formatPrice(item.price)}
				</span>
				<input
					value={quantity}
					onChange={(e) => {
						if (e.target.value === '') {
							setQuantity(0)
						} else setQuantity(parseInt(e.target.value))
					}}
					type="number"
					min="0"
					max="300"
					inputMode="numeric"
					pattern="[0-9]*"
					className="min-w-[64px] max-w-[84px] border-slate-200"
					disabled={disable}
				/>
			</div>
		</div>
	)
}
